'use client';

import React, {useCallback} from 'react';

import {IntroComponent} from '@web-catalog/components/Featuring/parts';
import {ContentRenderer} from '@web-catalog/components/Featuring/parts/ContentRenderer';

import {AppsSelection} from '@web-catalog/types';

import {useRunAfterAuthorizationDoneWithVkId} from '@web-catalog/store/auth';

import {
  getFeaturingAnalyticsType,
  useFeaturingAnalytics,
} from '@web-catalog/utils/analytics/useFeaturingAnalytics';

type Props = {
  featuringData: AppsSelection;
  featuringName: string;
  isEnablePreorderRedesign: boolean;
  showBackButton: boolean;
};

export const FeaturingView: React.FC<Props> = ({
  featuringData,
  featuringName,
  isEnablePreorderRedesign,
  showBackButton,
}) => {
  const {title, id, subtitle, imageUrl, content, type, displayType} =
    featuringData;
  const {logPageView} = useFeaturingAnalytics();

  const featuringType = getFeaturingAnalyticsType(type, displayType);

  useRunAfterAuthorizationDoneWithVkId(
    useCallback(() => {
      logPageView(id, featuringName, type, displayType);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  return (
    <>
      <IntroComponent
        subtitle={subtitle}
        title={title}
        imageUrl={imageUrl}
        showBackButton={showBackButton}
      />
      <ContentRenderer
        isEnablePreorderRedesign={isEnablePreorderRedesign}
        content={content}
        featuringName={featuringName}
        featuringId={id}
        featuringType={featuringType}
      />
    </>
  );
};
